import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class DatevWizardConfigDetailsActions {

  private static readonly prefix = '[Datev Wizard Config Details]';

  /**
   * Initiiert das Erneuern der DATEV-Verbindung (Reconnect).
   * Funktioniert nur für bestehende inaktive Konfigurationen.
   */
  public static readonly connectToDatev = createAction(
    `${this.prefix} Reconnect to DATEV`,
  );

  /**
   * Wird aufgerufen, wenn die Verbindung erfolgreich hergestellt wurde.
   * Enthält die Login-URL für die Weiterleitung.
   */
  public static readonly connectToDatevSuccess = createAction(
    `${this.prefix} Connect to DATEV Success`,
    props<{
      loginUrl: string;
    }>(),
  );

  /**
   * Wird aufgerufen, wenn beim Verbinden ein Fehler aufgetreten ist.
   */
  public static readonly connectToDatevFailure = createAction(
    `${this.prefix} Connect to DATEV Failure`,
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  /**
   * Initiiert das Trennen der DATEV-Verbindung.
   */
  public static readonly disconnectFromDatev = createAction(
    `${this.prefix} Disconnect from DATEV`,
  );

  /**
   * Wird aufgerufen, wenn die Verbindung erfolgreich getrennt wurde.
   */
  public static readonly disconnectFromDatevSuccess = createAction(
    `${this.prefix} Disconnect from DATEV Success`,
  );

  /**
   * Wird aufgerufen, wenn beim Trennen ein Fehler aufgetreten ist.
   */
  public static readonly disconnectFromDatevFailure = createAction(
    `${this.prefix} Disconnect from DATEV Failure`,
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  /**
   * Speichert die Änderungen an der Konfiguration (Datum und Export-Einstellungen).
   */
  public static readonly saveConfiguration = createAction(
    `${this.prefix} Save Configuration`,
    props<{
      exportDate?: string;
      exportDateIndependent: boolean;
    }>(),
  );

  /**
   * Löscht die gesamte Konfiguration.
   */
  public static readonly deleteConfiguration = createAction(
    `${this.prefix} Delete Configuration`,
  );

  /**
   * Wird aufgerufen, wenn die Konfiguration erfolgreich gelöscht wurde.
   */
  public static readonly deleteConfigurationSuccess = createAction(
    `${this.prefix} Delete Configuration Success`,
  );

  /**
   * Wird aufgerufen, wenn beim Löschen ein Fehler aufgetreten ist.
   */
  public static readonly deleteConfigurationFailure = createAction(
    `${this.prefix} Delete Configuration Failure`,
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  /**
   * Navigiert zur Case-Selection Seite nach dem Löschen der Konfiguration.
   * Behält die Firmen-ID bei.
   */
  public static readonly goToCaseSelection = createAction(
    `${this.prefix} Go to Case Selection`,
    props<{
      firmenId: string;
    }>(),
  );

  /**
   * Navigiert zur Client-ID Seite nach dem Löschen der Konfiguration.
   * Behält die Firmen-ID bei.
   */
  public static readonly goToClientId = createAction(
    `${this.prefix} Go to Client ID`,
    props<{
      firmenId: string;
    }>(),
  );

  /**
   * Action zum Aktualisieren der Export-Konfiguration.
   * Sendet die neuen Export-Einstellungen (ConnectionName + ggf. Export-Datum) an die API.
   */
  public static readonly updateExportConfiguration = createAction(
    `${this.prefix} Update Export Configuration`,
    props<{
      connectionName: string;
      exportDate?: string;
      exportDateIndependent: boolean;
    }>(),
  );

  /**
   * Action für erfolgreiche Aktualisierung der Export-Konfiguration.
   */
  public static readonly updateExportConfigurationSuccess = createAction(
    `${this.prefix} Update Export Configuration Success`,
    props<{
      connectionName: string;
      exportDate?: string;
      exportDateIndependent: boolean;
    }>(),
  );

  /**
   * Action für fehlgeschlagene Aktualisierung der Export-Konfiguration.
   */
  public static readonly updateExportConfigurationFailure = createAction(
    `${this.prefix} Update Export Configuration Failure`,
    props<{ error: MappedHttpErrorResponse }>(),
  );

  /**
   * Setzt die Pagination-Parameter für Error-Events.
   * Triggert automatisch ein Neuladen der Jobs über den Effect.
   */
  public static readonly setErrorEventsPageable = createAction(
    `${this.prefix} Set Error Events Pageable`,
    props<{ number: number; size: number }>(),
  );

}
